/* eslint-disable fp/no-mutation */
/* eslint-disable fp/no-mutating-methods */
import { ReactElement, useEffect, useState } from 'react'

import Alert from '@mui/material/Alert'
import Avatar from '@mui/material/Avatar'
import Snackbar from '@mui/material/Snackbar'
import Typography from '@mui/material/Typography'

import theme from 'src/theme'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  fetchCredentials,
  selectCredentials,
  selectCredentialsStatus,
  fetchLinkedServices,
  selectLinkedServices,
  selectLinkedServicesStatus,
  fetchLicenses,
  selectLicenses,
  selectLicensesStatus,
} from 'src/v3/profile/profile.slice'
import { CredentialIcon, InfoIcon } from 'src/v3/core/icons'
import Subheader from 'src/v3/components/subheader'
import { CredentialList } from 'src/v3/components/credential-list'
import useSession from 'src/authentication/hooks/use-session'
import { Container } from '@mui/material'
import Loading from 'src/v3/components/loading'
import { LicenseList } from '../components/license-list'

export default (): ReactElement => {
  let dispatch = useAppDispatch()
  let session = useSession()

  let credentialsStatus = useAppSelector(selectCredentialsStatus)
  let credentials = useAppSelector(selectCredentials)
  let licenses = useAppSelector(selectLicenses)
  let licensesStatus = useAppSelector(selectLicensesStatus)
  let linkedServices = useAppSelector(selectLinkedServices)
  let linkedServicesStatus = useAppSelector(selectLinkedServicesStatus)

  let [errorMessage, setErrorMessage] = useState<string>('')

  useEffect(() => {
    if (credentialsStatus === 'uninitialized') {
      dispatch(fetchCredentials())
    }
  }, [credentialsStatus])

  useEffect(() => {
    if (licensesStatus === 'uninitialized') {
      dispatch(fetchLicenses())
    }
  }, [licensesStatus])

  useEffect(() => {
    if (linkedServicesStatus === 'uninitialized') {
      dispatch(fetchLinkedServices())
    }
  }, [linkedServicesStatus])

  let verificationEnabled =
    session?.linkedServices.some(
      (lsid) =>
        linkedServices.find((ls) => ls.id === lsid)?.credentialVerification ===
        'full',
    ) || false

  return (
    <>
      <div className="flex items-center justify-center my-2">
        <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
          <CredentialIcon />
        </Avatar>
        <Typography
          variant="h4"
          className="pl-2"
          style={{
            fontFamily: 'smileAndWave',
          }}
        >
          Credentials
        </Typography>
      </div>
      <Typography
        textAlign="center"
        color="text.secondary"
        sx={{ marginBottom: -1 }}
      >
        View and manage your credentials
      </Typography>
      <Subheader title="Licenses & Certification" />
      <Container maxWidth="xl">
        <div className="flex">
          <InfoIcon />
          <Typography variant="body1" color="text.secondary" className="pl-1">
            You may add all your additional state licenses here. Your primary
            license from your bio is already added. Any additional licenses you
            add will influence the states we automatically submit your CE
            credits to. You may flag one of of your licenses as "secondary" if
            you would like it to be listed on your PDF certificate along with
            the primary license.
          </Typography>
        </div>
        <hr className="my-4" />
      </Container>
      <LicenseList
        licenses={licenses}
        fetchLicenses={fetchLicenses as any}
        setErrorMessage={setErrorMessage}
      />
      <Subheader title="Credentials" />
      <CredentialList
        credentials={credentials}
        verificationEnabled={verificationEnabled}
        fetchCredentials={fetchCredentials as any}
        setErrorMessage={setErrorMessage}
      />
      <Snackbar open={!!errorMessage} onClose={() => setErrorMessage('')}>
        <Alert
          variant="filled"
          onClose={() => setErrorMessage('')}
          severity="error"
        >
          {errorMessage}
        </Alert>
      </Snackbar>
      <Loading
        entities={[credentialsStatus, licensesStatus, linkedServicesStatus]}
      />
    </>
  )
}
